import { Injectable } from '@angular/core';
import { ApiBasic } from '../services/api-basic';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore'

import { Observable, from } from "rxjs";
import { map } from "rxjs/operators"
@Injectable({
    providedIn: 'root'
})

export class versionFirebaseService {

    firebaseVersion

    constructor(
        public http: HttpClient,
        public api: ApiBasic,
        public afs: AngularFirestore
    ) {
        this.firebaseVersion = afs.collection("versions").doc("webVersion").valueChanges()
    }

    public getFirebaseVersion() {
        return this.firebaseVersion;
    }

    getFirebaseAlert() {
        return this.afs.collection("versions").doc("alert").valueChanges()
    }

    getTypeBase() {
        return this.afs.collection("versions").doc("baseUrl").valueChanges()
    }

    
}